import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import workspaceService from "@services/workspace.service";

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

export const fetchWorkspaceAsync = createAsyncThunk(
  "workspace/fetchWorkspace",
  async () => {
    const response = await workspaceService.fetchWorkspaces();
    return response.data;
  }
);

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    addWorkspace: (state, action) => {
      state.data = [...state.data, action.payload];
    },
    removeWorkspace: (state, action) => {
      state.data = [...state.data].filter((x) => x._id !== action.payload);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkspaceAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWorkspaceAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = [...action.payload];
      })
      .addCase(fetchWorkspaceAsync.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      });
  },
});

// eslint-disable-next-line
export const { addWorkspace, removeWorkspace } = workspaceSlice.actions;

export default workspaceSlice.reducer;
